
import RegistrationForm from "@/components/sections/RegistrationForm";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

const Register = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <div className="pt-8">
        <section className="py-8 sm:py-12 md:py-16 bg-white">
          <div className="container mx-auto px-3 sm:px-6">
            <RegistrationForm />
          </div>
        </section>
      </div>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Register;
